import { Button } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

interface SaveButtonPropTypes {
  isSaving?: boolean;
  disabled?: boolean;
}

export const SaveButton = ({
  isSaving = false,
  disabled = false,
}: SaveButtonPropTypes) => {
  const { language } = useLanguage();

  return (
    <div className="col-lg-10 py-10 d-flex justify-content-end gap-8">
      <Button
        htmlType="submit"
        loading={isSaving}
        disabled={disabled}
        fill="outline"
        type="primary"
        size="sm"
      >
        {language === "en" ? "Save" : "সংরক্ষণ"}
      </Button>
    </div>
  );
};
